var map = {
	"./leadershipBD1.jpg": 95312,
	"./leadershipBD2.jpg": 67017,
	"./leadershipBD3.jpg": 56191,
	"./leadershipBD4.jpg": 77525,
	"./leadershipBD5.jpg": 9241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90179;